<template>
  <v-dialog
    :model-value="loading"
    fullscreen
    :scrim="false"
    persistent
    transition="none"
  >
    <v-card height="100%">
      <v-container class="fill-height">
        <v-row justify="center" align="center">
          <v-card-text class="text-center">
            <v-progress-circular
              :size="100"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-card-subtitle class="text-center mt-5">
              {{ $t('SurveyLoader.holdOn') }}
            </v-card-subtitle>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyLoader',
  props: {
    loading: Boolean,
  },
});
</script>
